import './header.scss';
import 'fullpage.js';

export default async () => {
	// Toggle
	$( '.js-toggle-menu' ).click( function () {
		$( this ).toggleClass( 'active' );
		$( '.header__menu' ).toggleClass( 'header__menu--open' );

		return false;
	} );

	// Sticky
	$( window ).scroll( function () {
		if ( $( this ).scrollTop() > 5 ) {
			$( '.header' ).addClass( 'header--sticky' );
		} else {
			$( '.header' ).removeClass( 'header--sticky' );
		}
	} );

	// Scroll
	const header = document.querySelector( '.header' );
	const logos = document.querySelectorAll( '.header__logo, .header__toggle' );
	const targetWrappers = document.querySelectorAll( '.hero, .banner, .js-news-slider, .js-service-slider, .js-project-slider, .footer' );

	$( '#fullpage' )[ 0 ] && $( '#fullpage' ).fullpage( {
		navigation: true,
		slidesNavigation: true,
		controlArrows: false,
		licenseKey: 'B6PMK-O7O06-5JE5I-VNLF7-KVUKM',
		responsiveWidth: 768,
		onLeave: function ( origin, destination, direction ) {
			let logoColorChanged = false;

			$( '#fullpage' ).find( 'video' ).each( ( i, video ) => video.pause() );
			$( destination.item ).find( 'video' ).each( ( i, video ) => video.play() );

			[
				'.hero',
				'.design-slider',
				'.footer',
			].forEach( ( Class ) => {
				if ( $( destination.item ).find( Class ).length ) {
					logos.forEach( ( logo ) => logo.classList.add( 'is-dark' ) );
					logoColorChanged = true;
				}
			} );

			if ( !logoColorChanged ) {
				logos.forEach( ( logo ) => logo.classList.remove( 'is-dark' ) );
			}

			$( '.design-slider__item' ).eq( 0 ).click();
			if ( destination.index ) {
				$( '.header' ).addClass( 'header--sticky' );
			} else {
				$( '.header' ).removeClass( 'header--sticky' );
			}
		},
	} );

	// Scroll header change color
	function checkHeaderPosition () {
		const headerRect = header.getBoundingClientRect();
		let logoColorChanged = false;

		targetWrappers.forEach( ( wrapper ) => {
			const wrapperRect = wrapper.getBoundingClientRect();

			if ( headerRect.bottom > wrapperRect.top && headerRect.top < wrapperRect.bottom ) {
				logos.forEach( ( logo ) => logo.classList.add( 'is-dark' ) );
				logoColorChanged = true;
			}
		} );

		if ( !logoColorChanged ) {
			logos.forEach( ( logo ) => logo.classList.remove( 'is-dark' ) );
		}
	}

	window.addEventListener( 'scroll', checkHeaderPosition );
	window.addEventListener( 'resize', checkHeaderPosition );
	checkHeaderPosition();
};
